import { mapGetters } from 'vuex';
// com
import AccountSet from './account-set/account-set.vue'; // 账号设置
import DetailInfo from './detail-info/detail-info.vue'; // 详细信息
import BankCardInfo from './bank-card-info/bank-card-info.vue'; // 银行卡信息
import ImageInfo from './image-info/image-info.vue'; // 影像信息
import AuthorizerInfo from './authorizer-info/authorizer-info.vue';
import accountInfoService from '../account-info.service.js';

export default {
  components: {
    AccountSet,
    DetailInfo,
    BankCardInfo,
    ImageInfo,
    AuthorizerInfo
  },
  data() {
    return {
      basicInfo: {}
    };
  },
  computed: {
    ...mapGetters([
      'loginUserType'
    ])
  },
  mounted() {
    this.getUserBaseInfo();
  },
  methods: {
    // 获取用户账户信息
    getUserBaseInfo(){
      accountInfoService.getUserBaseInfo().then(res => {
        if (res && res.code === '0') {
          this.basicInfo = res.data;
        }
      });
    }
  }
};
